// extracted by mini-css-extract-plugin
export var item = "DashboardItem-module--item--IwCw7";
export var productItem = "DashboardItem-module--productItem--ErYZc";